import axios from "axios";

const api = axios.create({
  baseURL: "https://api.rainbowlifts.com/api",
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    const data = response.data;
    if (data?.status === "error") {
      return Promise.reject({
        message: data.message || "Something went wrong",
        data,
      });
    }
    return data;
  },
  (error) => {
    console.error("API Error Response:", error.response?.data || error.message);
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      window.location.href = "/login";
    } else if (error.response?.status === 403) {
      return Promise.reject({
        message: "You do not have permission to perform this action.",
        data: error.response.data,
      });
    }
    return Promise.reject(error);
  },
);
export default api;
